module.exports = __webpack_public_path__ + "img/7800.9999f318.jpg";